import React, { useContext, useRef } from "react";
import { FaChartLine, FaQuestionCircle } from "react-icons/fa";
import { Link, Route, Routes } from "react-router-dom";
import { useAccount, useAccountID } from "../store/account";
import { useUi } from "../store/ui";
import { AccountMenu } from "./AccountNav";
import AccountsMenu from "./AccountsMenu";
import { ShowsNav } from "./ShowsNav";
import "./left-nav.scss";
import { LayoutContext } from "../layout/Layout";
import { useEffect } from "react";

export default function LeftNav() {
    return (
        <Routes>
            <Route path="profile" element={<Empty />} />
            <Route path=":accountID/*" element={<Nav />} />
        </Routes>
    );
}

export function Nav() {
    const layoutRef = useContext(LayoutContext);
    const handleRef = useRef();

    useEffect(() => {
        // The more modern drag-and-drop api controls the cursor and doesn't look right
        // for a resize, so we do it old school.

        let offset = 0;

        function mouseMove(event) {
            const { clientX } = event;
            if (clientX > 210 && clientX < 800) {
                layoutRef.current.style.setProperty("--left-width", `${ clientX + offset }px`);
            }
        }

        function mouseUp(event) {
            document.removeEventListener("mousemove", mouseMove);
            document.removeEventListener("mouseup", mouseUp);
            document.body.style.userSelect = "initial";
        }

        function mouseDown(event) {
            const {
                clientX,
                target: { offsetLeft, offsetWidth }
            } = event;

            // Cache an offset to account for the mouse being on the handle
            // which means the clientX is slightly left of the actual edge

            offset = offsetLeft - clientX;

            document.addEventListener("mousemove", mouseMove);
            document.addEventListener("mouseup", mouseUp);
            document.body.style.userSelect = "none";
        }

        handleRef.current.addEventListener("mousedown", mouseDown);

        return () => {
            handleRef.current?.removeEventListener("mousedown", mouseDown);
        };
    }, []);

    return (
        <nav className="left-nav">
            <AccountNav />
            <ShowsNav />
            <footer>
                <ul>
                    <li className="item hover">
                        <Link to="help">
                            <FaQuestionCircle style={{ verticalAlign: "-0.12em" }} />{" "}
                            <strong>Help / Support</strong>
                        </Link>
                    </li>
                </ul>
                <div className="legal">
                    <ul>
                        <li>
                            <a href="https://analytics.podtrac.com/tos" target="_blank">
                                Terms of Service
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://analytics.podtrac.com/site-privacy-policy"
                                target="_blank"
                            >
                                Privacy Policy
                            </a>
                        </li>
                    </ul>
                    © 2005-{new Date().getFullYear()} Podtrac, Inc. All rights reserved.
                </div>
            </footer>
            <div className="handle" ref={handleRef}></div>
        </nav>
    );
}

function NavHeading(props) {
    return <h1 {...props} className="item" />;
}

function NavLabel(props) {
    return <span {...props} className="label" />;
}

function NavItem({ className, ...props }) {
    return <li {...props} className={`item ${className}`} />;
}

function AccountNav() {
    const accountID = useAccountID();
    const { data: account } = useAccount();
    const { main } = useUi();
    return (
        <>
            <NavHeading>
                <NavLabel>Account</NavLabel> <AccountsMenu />
            </NavHeading>
            <ul className={`hover ${main == "KeyMetrics" ? "active" : ""}`}>
                {accountID && (
                    <>
                        <NavItem style={{ fontWeight: 700 }}>
                            <Link className="label" to={`/dashboard/${accountID}`}>
                                {(account && account.accountName) || "\u2026"}
                            </Link>
                            <AccountMenu />
                        </NavItem>
                        <NavItem>
                            <Link className="label" to={`/dashboard/${accountID}`}>
                                <FaChartLine />
                                Key Metrics
                            </Link>
                        </NavItem>
                    </>
                )}
            </ul>
        </>
    );
}

const Empty = () => null;
